<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import { useMessageContext } from '../provider.js';
import { CONTENT_TYPES } from '../constants';
import { actionUrl } from '../helpers/interactiveEcho';

const { content, contentType, contentAttributes } = useMessageContext();
const options = computed(() =>
  contentType.value === CONTENT_TYPES.INPUT_SELECT
    ? contentAttributes.value.items || []
    : []
);
const links = computed(() =>
  contentType.value === CONTENT_TYPES.CARDS
    ? (contentAttributes.value.items || []).flatMap(card =>
        (card.actions || [])
          .filter(action => action.type === 'link' && actionUrl(action.uri))
          .map(action => ({ text: action.text, href: actionUrl(action.uri) }))
      )
    : []
);
const footer = computed(() => contentAttributes.value.whatsapp?.footer);
</script>

<template>
  <BaseBubble class="px-4 py-3 min-w-56" data-bubble-name="interactive">
    <p class="m-0 whitespace-pre-wrap break-words">{{ content }}</p>
    <p v-if="footer" class="mt-2 mb-0 text-xs text-n-slate-11">
      {{ footer }}
    </p>
    <div class="flex flex-col gap-2 mt-3">
      <a
        v-for="link in links"
        :key="link.href"
        :href="link.href"
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center justify-center gap-2 rounded-lg border border-n-weak bg-n-alpha-1 px-3 py-2 text-n-blue-11 font-medium hover:bg-n-alpha-2 focus-visible:ring-2 focus-visible:ring-n-blue-9"
      >
        <Icon icon="i-lucide-external-link" class="size-4" />
        {{ link.text }}
      </a>
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        disabled
        :data-option-id="option.value"
        class="flex items-center justify-center gap-2 rounded-lg border border-n-weak bg-n-alpha-1 px-3 py-2 text-n-blue-11 font-medium cursor-default"
      >
        <Icon icon="i-lucide-reply" class="size-4" />
        {{ option.title }}
      </button>
    </div>
  </BaseBubble>
</template>
